/* eslint-disable no-param-reassign */
import { UPDATE_APP_DATA } from 'constants/action_types'
import { createActionTypeReducer } from 'util/reducers'
import { updateCount as updateFaviconCount } from 'util/favicon'
import {
  ROOMS_REALTIME_SYNC_UNREAD,
  ROOM_OPTIMISTIC_COMPLETE,
} from 'ducks/chat/actionTypes/rooms'
import { SEARCH_SYNC } from 'ducks/searches/actionTypes'
import { FETCH_CURRENT_USER_SUCCESS } from 'ducks/currentUser/types'

const initialState = {
  unreadRoomIds: [],
  unread: false,
  pendingUnreadRoomIds: [],
}

export default createActionTypeReducer(
  {
    [ROOMS_REALTIME_SYNC_UNREAD]: (draftState, action) => {
      const {
        payload: { agents, currentUser, isInChat },
      } = action

      const agentUnread = agents[`ag_${currentUser?.id}`]
      if (currentUser && !isInChat && agentUnread !== undefined) {
        draftState.unread = agentUnread
        updateFaviconCount(draftState.unread ? 1 : 0)
      }
    },
    [SEARCH_SYNC]: (draftState, action) => {
      const {
        payload: {
          currentUser,
          unread,
          isInChat,
          searches,
          currentConversationId,
        },
      } = action
      const agentUnread = unread[`ag_${currentUser?.id}`]
      if (agentUnread === undefined) return

      const hasNonCurrentConversationChange = Object.keys(searches)
        .filter(f => f.includes('folderunread'))
        .some(sk => {
          const search = searches[sk]
          const hasPlusChanges =
            search.plus.filter(
              conversationId => conversationId !== currentConversationId
            ).length > 0
          const hasEqualChanges = search.equal.length > 0
          const hasMinusChanges = search.minus.length > 0
          return hasPlusChanges || hasEqualChanges || hasMinusChanges
        })

      if (currentUser && isInChat && hasNonCurrentConversationChange) {
        draftState.unread = agentUnread
        updateFaviconCount(draftState.unread ? 1 : 0)
      }
    },
    [FETCH_CURRENT_USER_SUCCESS]: (draftState, action) => {
      const {
        data: {
          currentUser: { hasUnreadChat },
        },
      } = action
      draftState.unread = hasUnreadChat
      updateFaviconCount(draftState.unread ? 1 : 0)
    },
    [UPDATE_APP_DATA]: (draftState, action) => {
      const {
        data: {
          currentUser: { hasUnreadChat },
        },
      } = action
      draftState.unread = hasUnreadChat
      updateFaviconCount(draftState.unread ? 1 : 0)
    },
    [ROOM_OPTIMISTIC_COMPLETE]: (draftState, action) => {
      const {
        payload: { isUnread },
      } = action
      draftState.unread = isUnread
      updateFaviconCount(draftState.unread ? 1 : 0)
    },
  },
  initialState
)
